define('gamebox/math/inverselerp', ['exports', 'module', './lerp'], function (exports, module, _lerp) {
  'use strict';

  function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

  var _lerp2 = _interopRequire(_lerp);

  'use strict';

  var inverseLerp = function inverseLerp(min, max, amt) {
    return max - _lerp2(min, max, amt);
  };

  module.exports = inverseLerp;
});